import { Chip, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import { Dispatch, SetStateAction, useState } from 'react';
import { MealRequestDTO } from '../../model/MealRequestDTO';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Meal } from '../../model/Meal';
import { Customer } from '../../model/Customer';
import { SaveEditMealModal } from '../modal/SaveEditMealModal';
import { Entities } from '../util/Entities';
import { CustomersToMealTransferModal } from '../modal/CustomersToMealTransferModal';
import { isMobile } from 'react-device-detect';
import { Badge, Dropdown, MenuProps } from 'antd';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { DeleteRestoreDialog } from '../util/DeleteRestoreDialog';
import { HardDeleteDialog } from '../util/HardDeleteDialog';

export const MealElement : React.FC<{meal : Meal, customerList : Customer[]
    show : boolean, setShow : Dispatch<SetStateAction<boolean>>, index : number,
    handleSaveToDatabase : (mealRequestDTO: MealRequestDTO) => Promise<() => void>,
    handleDeleteOrRestore : (id: number, idDelete : boolean) => Promise<() => void>,
    handleHardDelete : (id: number) => Promise<() => void>,
    isListLimitActive : boolean
    isListLimitInactive : boolean
}> = (props) => {

    const {meal, customerList, index, handleSaveToDatabase, handleDeleteOrRestore, handleHardDelete, isListLimitActive, isListLimitInactive} = props
    const [show, setShow] = useState(false);
    const [showTransfer, setShowTransfer] = useState<boolean>(false)
    const [showDeleteRestoreDialog, setShowDeleteRestoreDialog] = useState<boolean[]>([false,false]);
    const [showHardDeleteDialog, setShowHardDeleteDialog] = useState<boolean>(false)

    const items: MenuProps['items'] = [
      {
        label: (
          <IconButton onClick={() => setShow(true)}>
            <EditIcon />
          </IconButton>
        ),
        key: '0',
      },
      {
        label: (
          <IconButton color={`warning`} disabled ={(meal.active === true && isListLimitInactive ) || (meal.active === false && isListLimitActive)} onClick={() => {setShowDeleteRestoreDialog([true, meal.active === true])}}>
            {meal.active === true ? <DeleteIcon /> : <RestoreFromTrashIcon/>}
          </IconButton>
        ),
        key: '1',
      },
      {
        label: (
          <IconButton onClick={() => {setShowTransfer(true)}} disabled={meal.active === false}>
            <LibraryAddIcon />
          </IconButton>
        ),
        key: '2',
      },
      {
        label: (
          <IconButton color={`error`} onClick={() => {setShowHardDeleteDialog(true)}}>
            <DeleteIcon />
          </IconButton>
        ),
        key: '3',
      },
      
    ];

    return (
        <tr className={isMobile ? 'mobile-text-size align-middle' : 'align-middle' }>
              <td>{index+1}</td>
              <td>{meal.position}</td>
              <td>
                {`${meal.details} `}
                {meal.active ? 
                    ""
                    :
                    <Tooltip title="Ten posiłek został wcześniej usunięty. Na tej stronie będzie widoczny tylko do końca bieżącego miesiąca" 
                        arrow placement="right">
                        <ErrorOutlineIcon fontSize="small" sx={{ color: 'orange' }}/>
                    </Tooltip>
                }
              </td>
              <td>
                {meal.amount.toLocaleString("pl-PL", {style:"currency", currency:"PLN"})}
                {isMobile ? <Badge className='mx-1' color={meal.singlePayment ? `rgb(30, 174, 152)` : `rgb(116, 116, 116)`}/> :<></>}
              </td>
              {isMobile ?
              <td>
                <Dropdown menu={{ items }} trigger={['click']}>
                  <MoreVertIcon />
                </Dropdown>
              </td>
              :
              <>
              <td>
              <Chip className={`custom-chip ${meal.singlePayment ? `` : `custom-chip-inactive`}`} 
                            variant="outlined" 
                            color="secondary" 
                            label ={meal.singlePayment ? `Stawka miesięczna` : `Stawka dzienna`} />
              </td>
              <td>
                  <Tooltip TransitionComponent={Zoom} title="Edytuj posiłek">
                    <IconButton onClick={() => setShow(true)}>
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                  <>
                    <IconButton onClick={() => {setShowTransfer(true)}} disabled={meal.active === false}>
                        <Tooltip TransitionComponent={Zoom} title="Przypisz rodziców">
                            <LibraryAddIcon />
                        </Tooltip>
                    </IconButton>
                  </>
                  <>
                    <IconButton color={`warning`} disabled ={(meal.active === true && isListLimitInactive ) || (meal.active === false && isListLimitActive)} onClick={() => {setShowDeleteRestoreDialog([true, meal.active === true])}}>
                        <Tooltip TransitionComponent={Zoom} title={`${meal.active === true ? `Usuń` : `Odtwórz`} posiłek`}>
                            {meal.active === true ? <DeleteIcon /> : <RestoreFromTrashIcon/>}
                        </Tooltip>
                    </IconButton>
                  </>
                  <>
                  <IconButton color={`error`} onClick={() => {setShowHardDeleteDialog(true)}}>
                      <Tooltip TransitionComponent={Zoom} title={`Usuń trwale posiłek`}>
                        <DeleteIcon />
                      </Tooltip>
                  </IconButton>
                  </>
              </td>
              </>
              }
              <td>
                <SaveEditMealModal meal={meal} customerList ={customerList} show={show} setShow={setShow} index={index} handleSaveToDatabase={handleSaveToDatabase}/>
                <CustomersToMealTransferModal meal={meal} customerList={customerList} index={index} showTransfer={showTransfer} setShowTransfer={setShowTransfer}/>  
                <DeleteRestoreDialog idToDelete={meal.mealid!} showDeleteRestoreDialog={showDeleteRestoreDialog} setShowDeleteRestoreDialog={setShowDeleteRestoreDialog} handleDeleteOrRestore={handleDeleteOrRestore} entity={Entities.MEAL}/>
                <HardDeleteDialog idToDelete={meal.mealid!} showHardDeleteDialog={showHardDeleteDialog} setShowHardDeleteDialog={setShowHardDeleteDialog} handleHardDelete={handleHardDelete} entity={Entities.MEAL}/>
              </td>
        </tr>
    )
}